export function extractDeviceType(deviceName) {
    if (!deviceName) return null;

    const knownTypes = ['SIS', 'RA', 'ALC', 'OW', 'TI'];
    for (const type of knownTypes) {
        if (deviceName.includes(`${type}`)) {
            return type;
        }
    }

    return null;
}

export function getDeviceLocation() {
    return [
        { id: 1, x: 2521, y: 1986 },
        { id: 2, x: 3802, y: 930 },
        { id: 3, x: 3089, y: 1012 },
        { id: 4, x: 548, y: 1513 },
        { id: 5, x: 2844, y: 1001 },
        { id: 6, x: 3035, y: 1954 },
        { id: 7, x: 804, y: 1104 },
        { id: 8, x: 2666, y: 1025 },
        { id: 9, x: 3509, y: 1872 },
        { id: 10, x: 2555, y: 1909 },
        { id: 11, x: 543, y: 1639 },
        { id: 12, x: 2843, y: 1054 },
        { id: 13, x: 748, y: 1307 },
        { id: 14, x: 3031, y: 2048 },
        { id: 15, x: 3177, y: 2006 },
        { id: 16, x: 3570, y: 910 },
        { id: 17, x: 2399, y: 1575 },
    ];
}
